export default {
	variants: [
		{
			props: { variant: 'info' },
		},
		{
			props: { variant: 'success' },
		},
		{
			props: { variant: 'error' },
		},
		{
			props: { variant: 'warning' },
		},
	],
	styleOverrides: {
		root: ({ ownerState, theme }) => {
			const successStyles = {
				background: theme.palette.mode === 'dark' ? '#0C130D' : '#EDF7ED',
				color: theme.palette.mode === 'dark' ? '#CCE8CD' : '#1E4620',
				svg: {
					color: theme.palette.mode === 'dark' ? '#66BB6A' : '#2E7D32',
				},
			};
			switch (ownerState.variant) {
				case 'info':
					return {
						background: theme.palette.mode === 'dark' ? '#071318' : '#E5F6FD',
						color: theme.palette.mode === 'dark' ? '#B8E7FB' : '#014361',
						svg: {
							color: theme.palette.mode === 'dark' ? '#29B6F6' : '#0288D1',
						},
					};
				case 'success':
					return successStyles;
				case 'error':
					return {
						background: theme.palette.mode === 'dark' ? '#160B0B' : '#FDEDED',
						color: theme.palette.mode === 'dark' ? '#F4C7C7' : '#5F2120',
						svg: {
							color: theme.palette.mode === 'dark' ? '#F44336' : '#D32F2F',
						},
					};
				case 'warning':
					return {
						background: theme.palette.mode === 'dark' ? '#191207' : '#FFF4E5',
						color: theme.palette.mode === 'dark' ? '#FFE2B7' : '#663C00',
						svg: {
							color: theme.palette.mode === 'dark' ? '#FFA726' : '#ED6C02',
						},
					};
				default:
					// return success styles by default to mimic what MUI Alert does: https://mui.com/material-ui/api/alert/;
					return successStyles;
			}
		},
	},
};